import React, { memo } from "react";
import Pools from "components/Pools/Pools";
import Governance from "components/Governance/Governance";
import Clouds from "components/Clouds/Clouds";
import Windmills from "components/Windmills/Windmills";
import GlobalActions from "components/GlobalActions/GlobalActions";
import LGE from "components/LGE/LGE";
import SheepsAndShepard from "components/SheepsAndShepard/SheepsAndShepard";
import "./Main.scss";
import GovernanceStore from "stores/GovernanceStore";
import NFTGrid from "components/NFTGrid/NFTGrid";
import WalletUnlock from "components/WalletUnlock/WalletUnlock";
import BackButton from "components/BackButton/BackButton";

function Main() {
  const screenWidth = document.body.clientWidth;
  const displayDynamicContent = screenWidth > 1024 ? true : false;
  const { weightedNumber, totalYGY } = GovernanceStore;
  return (
    <WalletUnlock>
      <div className="main-content">
        {displayDynamicContent && <Windmills />}
        {displayDynamicContent && <SheepsAndShepard weightedNumber={weightedNumber} totalYGY={totalYGY} />}
        <div className="middle">
          <BackButton />
          {displayDynamicContent && <Clouds />}
          <GlobalActions />
          <NFTGrid />
        </div>
        <div className="bottom-wrapper">
          <div className="bottom">
            <LGE />
            <Pools />
            <Governance />
          </div>
        </div>
      </div>
    </WalletUnlock>
  );
}

export default memo(Main);
